
import { Component, Vue, Prop } from 'vue-property-decorator'

/**
 * @prop  isLink    是否链接
 * @prop  src       链接地址
 * @prop  label     标题
 * @prop  text      文本
*/
@Component({
    name: 'row-item'
})
export default class extends Vue {
    @Prop({ default: false }) private isLink!: boolean
    @Prop({ default: '' }) private src!: string
    @Prop({ default: '' }) private label!: string
    @Prop({ default: '' }) private text!: string
}
